/* istanbul ignore file */
// Doesn’t unit testing (we don’t want to test Vue)

import Vue from 'vue'
export default new Vue()
